module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_9005.07b05383.png";